import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("/tmp/tmpvyuryfzc/layouts/custom.vue").then(m => m.default || m))
}